import { useState } from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';

import { FeatureFlags } from './lib/util/flags/types';

import SearchSymbolModal from './components/SearchSymbolModal/SearchSymbolModal';
import { getTabName } from './util/helpers';
import { Downbar, Header, Sidebar } from './components';
import { useFlags, useIsMobile } from './hooks';

import styles from './HeaderAndSideBar.module.scss';

const HeaderAndSideBar = (): JSX.Element => {
  const { isMobile } = useIsMobile();
  const location = useLocation();
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
  const flags = useFlags([ FeatureFlags.referrals ]);
  const isReferralsEnabled = flags[FeatureFlags.referrals].enabled;

  const renderDownbar = (): JSX.Element => (
    <div className={classNames(styles.downBar, { [styles.hide]: getTabName(location, isReferralsEnabled) === 0 })}>
      <Downbar />
    </div>
  );

  return (
    <>
      <div className={isMobile ? styles.headerMobile : styles.header}>
        {!isMobile && <Sidebar />}
        <Header isSearchActive={(value) => setIsSearchOpen(value)} />
      </div>
      { isMobile && renderDownbar() }
      {isSearchOpen && <SearchSymbolModal onClose={() => setIsSearchOpen(false)} />}
    </>
  );
};

export default HeaderAndSideBar;
